module.exports = __webpack_public_path__ + "aa5099ebc75b1bc5d72ae58b4552a634.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/gef-score-example.png
// module id = 1560
// module chunks = 0